﻿import { FIQAssist } from "../app";
import { Component, Attribute, Input, Output, Inject } from "@fiqas/angular-utils";
import { CacheService } from "../services/cache";

@Component({
    module: FIQAssist,
    selector: 'scorebox',
    template: `<div tabindex="0" ng-keydown="$ctrl.onKey($event)" class="scorebox level-{{$ctrl.level}} ng-class:{'loading':$ctrl.loading}" ng-click="$ctrl.click($event)"
                tooltip-popup-delay="500" tooltip-placement="bottom" uib-tooltip="{{$ctrl.hint}}" tooltip-class="customTooltipTB" tooltip-popup-close-delay='500'>
                    <span class="score">
                        <span ng-if="!$ctrl.loading">{{$ctrl._score}}</span>
                        <span ng-if="$ctrl.loading" class="spinnerForScore"></span>
                    </span>
                    <span ng-hide="$ctrl.compact" class="feature">{{$ctrl.label}}</span>
                    <span class="target icon-search"><span class="path1"></span><span class="path2"></span></span>
            </div>`
})
export class ScoreBox {
    private _score: number;
    private _level: string;

    private initialized: boolean = false;

    @Input()
    public get score(): number {
        return this._score;
    }
    public set score(val: number) {
        if (this.initialized && val !== undefined)
            this._score = val;
    }

    @Input()
    public get level(): string {
        return this._level;
    }
    public set level(val: string) {
        if (this.initialized && val)
            this._level = val;
    }

    @Input() public loading: boolean;
    @Input() public label: string;
    @Input() public hint: string;
    @Input() public compact: boolean;
    @Attribute() public storeid: string;

    @Output() public onclicked: (args: { source: ScoreBox }) => void;

    public click(event: JQueryEventObject) {
        this.onclicked({ source: this });
    }

    public constructor(
        @Inject() private cacheService: CacheService
    ) {
    }

    public $onInit() {
        if (this.storeid) {
            this._score = this.cacheService.getValue<number>("scorebox." + this.storeid + ".score") || 0;
            this._level = this.cacheService.getValue<string>("scorebox." + this.storeid + ".level") || "none";
        }
        else {
            this._score = 0;
            this._level = 'none';
        }
        this.initialized = true;
    }

    public $onDestroy() {
        if (this.storeid) {
            this.cacheService.setValue<number>("scorebox." + this.storeid + ".score", this.score);
            this.cacheService.setValue<string>("scorebox." + this.storeid + ".level", this.level);
        }
    }

    private onKey($event: KeyboardEvent) {
        switch ($event.keyCode) {
            case 13:
            case 32:
                $event.preventDefault();
                this.onclicked({ source: this });
                break;
        }
    }

}
